import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

export const EntryListWidgetErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      fallback={
        <Box
          sx={{
            mt: 69.5,
            textAlign: 'center',
          }}
        >
          <Typography variant="text1" color="text.secondary">
            {t('common.somethingWrong')}
          </Typography>
        </Box>
      }
    >
      {children}
    </ErrorBoundary>
  );
};
